define('controllers/hotelcarousel',['require','fadegallery'],function(require) {
    var initSlideShow = require('fadegallery');
    return initSlideShow;
});

